import {
  CometChatMessageComposer,
  CometChatMessageHeader,
  CometChatMessageList,
} from '@cometchat/chat-uikit-react';
import React from 'react';
import './ChatDemo.css';
import { Icon } from './components';

interface ChatDemoProps {
  onClose: () => void;
  group?: any;
}

const ChatDemo: React.FC<ChatDemoProps> = ({ onClose, group }) => {
  return (
    <div className="chat-demo-panel">
      <div className="chat-header">
        <CometChatMessageHeader
          hideVideoCallButton={true}
          hideVoiceCallButton={true}
          titleView={<div className="chat-header__title">Chat</div>}
          onBack={onClose}
          showBackButton={true}
          group={group}
          subtitleView={<></>}
          leadingView={<></>}
          auxiliaryButtonView={
            <button className="chat-header__close-button" onClick={onClose}>
              <Icon
                name="close"
                fill="var(--cometchat-calls-icon-color-primary)"
                size={24}
              />
            </button>
          }
        />
      </div>

      <div className="chat-messages">
        {group ? (
          <CometChatMessageList disableSoundForMessages={true} group={group} />
        ) : (
          <div
            style={{
              padding: '20px',
              textAlign: 'center',
              color: '#666',
              height: '80%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            loading...
          </div>
        )}
      </div>

      <div className="chat-input">
        {group ? (
          <CometChatMessageComposer
            group={group}
            hideCollaborativeWhiteboardOption={true}
            hideAudioAttachmentOption={true}
            hideCollaborativeDocumentOption={true}
            hideImageAttachmentOption={true}
            hidePollsOption={true}
            hideVideoAttachmentOption={true}
            hideVoiceRecordingButton={true}
          />
        ) : (
          <div
            style={{
              padding: '10px',
              textAlign: 'center',
              color: '#666',
              width: '80%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            loading...
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatDemo;
